import * as tslib_1 from "tslib";
import { Image2D } from "../image/Image2D";
import { MaterialBase } from "../materials/MaterialBase";
import { Single2DTexture } from "../textures/Single2DTexture";
/**
 * BasicMaterial forms an abstract base class for the default shaded materials provided by Stage,
 * using material methods to define their appearance.
 */
var BasicMaterial = (function (_super) {
    tslib_1.__extends(BasicMaterial, _super);
    function BasicMaterial(imageColor, alpha) {
        if (imageColor === void 0) { imageColor = null; }
        if (alpha === void 0) { alpha = 1; }
        var _this = _super.call(this, imageColor, alpha) || this;
        _this._preserveAlpha = false;
        //set a texture if an image is present
        if (imageColor instanceof Image2D)
            _this.texture = new Single2DTexture();
        return _this;
    }
    Object.defineProperty(BasicMaterial.prototype, "assetType", {
        /**
         *
         */
        get: function () {
            return BasicMaterial.assetType;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BasicMaterial.prototype, "preserveAlpha", {
        /**
         * Indicates whether alpha should be preserved - defaults to false
         */
        get: function () {
            return this._preserveAlpha;
        },
        set: function (value) {
            if (this._preserveAlpha == value)
                return;
            this._preserveAlpha = value;
            this.invalidate();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BasicMaterial.prototype, "texture", {
        /**
         * The texture object to use for the albedo colour.
         */
        get: function () {
            return this._texture;
        },
        set: function (value) {
            if (this._texture == value)
                return;
            if (this._texture)
                this.removeTexture(this._texture);
            this._texture = value;
            if (this._texture)
                this.addTexture(this._texture);
            this.invalidateTexture();
        },
        enumerable: true,
        configurable: true
    });
    return BasicMaterial;
}(MaterialBase));
export { BasicMaterial };
BasicMaterial.assetType = "[materials BasicMaterial]";



// WEBPACK FOOTER //
// ../dist/lib/materials/BasicMaterial.js